import { render, staticRenderFns } from "./NewTabs.vue?vue&type=template&id=eb78255a&scoped=true"
import script from "./NewTabs.vue?vue&type=script&lang=js"
export * from "./NewTabs.vue?vue&type=script&lang=js"
import style0 from "./NewTabs.vue?vue&type=style&index=0&id=eb78255a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb78255a",
  null
  
)

export default component.exports